import Dropzone from "dropzone";
import { Controller } from "stimulus";
import { DirectUpload } from "@rails/activestorage";
import {
  getMetaValue,
  toArray,
  findElement,
  removeElement,
  insertAfter
} from "helpers";

export default class extends Controller {
  static targets = ["input", "attachButton"];
  static values = { activeUploads: Number };
  static filenumber = 0;

  connect() {
    this.initializeDropzone();
    this.hideFileInput();
    this.bindEvents();
    Dropzone.autoDiscover = false; // necessary quirk for Dropzone error in console
    this.activeUploadsValue = 0; // Initialize with zero uploads
  }




  initializeDropzone() {
    this.dropZone = new Dropzone(this.element, {
      url: this.url,
      headers: this.headers,
      maxFiles: this.maxFiles,
      maxFilesize: this.maxFileSize,
      acceptedFiles: this.acceptedFiles,
      addRemoveLinks: this.addRemoveLinks,
      capture: this.setCapture,
      autoQueue: false
    });
  }

  hideFileInput() {
    this.inputTarget.disabled = true;
    this.inputTarget.style.display = "none";
  }

  bindEvents() {
    this.dropZone.on("addedfile", file => {
      setTimeout(() => {
        if (file.accepted) {
          this.activeUploadsValue++; // Increment counter when file is added
          this.updateAttachButtonState();
          this.createDirectUploadController(file).start();
        }
      }, 500);
    });

    this.dropZone.on("removedfile", file => {
      if (file.controller) {
        removeElement(file.controller.hiddenInput);
        // Decrement only if file was being uploaded
        if (file.status === Dropzone.UPLOADING) {
          this.activeUploadsValue--;
          this.updateAttachButtonState();
        }
      }
    });

    this.dropZone.on("canceled", file => {
      if (file.controller) {
        file.controller.xhr.abort();
        this.activeUploadsValue--; // Decrement counter when upload is canceled
        this.updateAttachButtonState();
      }
    });

    // Add additional handlers for completed uploads
    this.dropZone.on("success", file => {
      this.activeUploadsValue--; // Decrement counter when upload is complete
      this.updateAttachButtonState();
    });

    this.dropZone.on("error", file => {
      this.activeUploadsValue--; // Decrement counter when upload errors
      this.updateAttachButtonState();
    });
  }

  get headers() {
    return { "X-CSRF-Token": getMetaValue("csrf-token") };
  }

  updateAttachButtonState() {
    if (($('#ImageSubmit')).length > 0) {
      const button = $('#ImageSubmit')[0];
      if (!button) return; // Ensure button exists

      if (this.activeUploadsValue > 0) {
        // Actually disable the button element
        button.disabled = true;
        button.classList.add("disabled");
        button.innerHTML = `<i class="fa fa-spinner fa-spin"></i> Uploading (${this.activeUploadsValue} remaining)...`;

        // Set data attribute for additional checking
        button.dataset.uploading = "true";
      } else {
        button.disabled = false;
        button.classList.remove("disabled");
        button.innerHTML = document.getElementById('attach-button-text').value;

        // Remove data attribute
        delete button.dataset.uploading;
      }
    }
  }





  get url() {
    return this.inputTarget.getAttribute("data-direct-upload-url");
  }

  get maxFiles() {
    return this.element.dataset.maxfiles || 1;
  }

  get maxFileSize() {
    return this.element.dataset.maxsize || 256;
  }

  get acceptedFiles() {
    return this.element.dataset.accfiles || ".jpg, .jpeg, .png, .gif, .pdf";
  }

  get addRemoveLinks() {
    return this.element.dataset.removelinks || true;
  }

  get setCapture() {
    return this.element.dataset.capture || null;
  }

  createDirectUploadController(file) {
    return new DirectUploadController(this, file);
  }
}

class DirectUploadController {
  constructor(source, file) {
    this.directUpload = this.createDirectUpload(file, source.url);
    this.source = source;
    this.file = file;
  }

  start() {
    this.file.controller = this;
    this.hiddenKey = this.createHiddenInput("ImageKey");
    this.hiddenFileName = this.createHiddenInput("title");
    this.directUpload.create((error, attributes) => {
      if (error) {
        removeElement(this.hiddenInput);
        this.emitDropzoneError(error);
      } else {
        this.hiddenKey.value = attributes.key;
        this.hiddenFileName.value = attributes.filename;
        this.emitDropzoneSuccess();
      }
    });
  }

  createHiddenInput(name) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    insertAfter(input, this.source.inputTarget);
    return input;
  }

  createDirectUpload(file, url) {
    return new DirectUpload(file, url, this);
  }

  directUploadWillStoreFileWithXHR(xhr) {
    xhr.setRequestHeader('chat-file-path', 'public-read');
    this.bindProgressEvent(xhr);
    this.emitDropzoneUploading();
  }

  bindProgressEvent(xhr) {
    this.xhr = xhr;
    this.xhr.upload.addEventListener("progress", event => this.uploadRequestDidProgress(event));
  }

  uploadRequestDidProgress(event) {
    const progress = (event.loaded / event.total) * 100;
    findElement(this.file.previewTemplate, ".dz-upload").style.width = `${progress}%`;
  }

  emitDropzoneUploading() {
    this.file.status = Dropzone.UPLOADING;
    this.source.dropZone.emit("processing", this.file);
  }

  emitDropzoneError(error) {
    this.file.status = Dropzone.ERROR;
    this.source.dropZone.emit("error", this.file, error);
    this.source.dropZone.emit("complete", this.file);
  }

  emitDropzoneSuccess() {
    this.file.status = Dropzone.SUCCESS;
    this.source.dropZone.emit("success", this.file);
    this.source.dropZone.emit("complete", this.file);
  }
}